<template>
  <v-dialog
    v-model="showDialog"
    max-width="660"
    @click:outside="cancelDialog"
    content-class="delete-dialog"
  >
    <v-card>
      <v-card-title>
        <h3>Disassociate <u>{{ selectedKeyToDelete.Title }}</u> key</h3>
      </v-card-title>

      <v-card-text>
        <p>Are you sure you want to disassociate this key?</p>
        <p>This action cannot be undone.</p>
      </v-card-text>

      <v-card-actions class="justify-center buttons">
        <v-btn
          text
          @click="cancelDialog"
        >
          Cancel
        </v-btn>

        <v-btn
          color="error darken-1"
          @click="confirmDialog"
        >
          <v-icon left>fas fa-trash</v-icon>
          Disassociate key
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({

	}),
  props: ['showDisassociateDialog', 'selectedKeyToDelete'],
  computed: {
    showDialog: {
      get() {
        return this.showDisassociateDialog;
      },
      set(value) {
        this.$emit('update:showDisassociateDialog', value)
      } 
    }
  },
  methods: {
    cancelDialog() {
      this.showDialog = false;
    },
    confirmDialog() {
      this.$emit('confirmDisassociateDialog', this.selectedKeyToDelete);
    }
	}
}
</script>

<style scoped>
.delete-dialog h3, p{
  font-family: 'Montserrat';
  text-align: center;
}

.delete-dialog h3 {
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.delete-dialog p {
  font-weight: 500;
}

.delete-dialog p:nth-child(2) {
  margin-top: -15px;
}

.delete-dialog .buttons {
  padding-bottom: 60px;
}

.buttons {
  font: 12px/15px "Montserrat";
}
</style>